import React from 'react'

function Button({ children, onClick, className, disabled, ...props }) {
    return (
        <button {...props} disabled={disabled} onClick={onClick} className={className? className: 'btn btn-primary'}>
            {children}
        </button>
    )
}

export default Button